import { CollapsibleGroup } from '@fiverr-private/disclosure';
import withImpression from '../helpers/withImpression';

export default withImpression(CollapsibleGroup);
